const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHECKOUT = "https://www.commas.com/checkout/1BXEGVH8mgBKgtv";
const STEPS = [
  "Parsing Business Logic...",
  "Synthesizing Industry Design...",
  "Weaving Neural Flow...",
  "Optimizing Conversion Loops...",
  "Deploying Core Instance...",
];

const CTA_BAR = `<div style="position:sticky;bottom:0;left:0;right:0;z-index:9999;background:#000;color:#fff;padding:14px 18px;display:flex;flex-wrap:wrap;gap:12px;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,sans-serif;">
<span style="font-weight:700;font-size:14px;">Purchase required to take your automation live.</span>
<button onclick="window.open('${CHECKOUT}', '_blank')" style="background:#0070ff;color:#fff;border:none;border-radius:12px;padding:12px 24px;font-weight:900;font-size:14px;cursor:pointer;">PURCHASE TO GO LIVE</button></div>`;

const LINK_GUARD = `<script>document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a');if(a){var h=a.getAttribute('href')||'';if(h.charAt(0)==='#'&&h.length>1){e.preventDefault();var t=document.querySelector(h);if(t)t.scrollIntoView({behavior:'smooth'});}else{e.preventDefault();}}});<\/script>`;

const cleanHtml = (raw) => {
  let html = raw.replace(/^\s*```(?:html)?\s*/i, "").replace(/```\s*$/, "").trim();
  const start = html.search(/<!doctype|<html/i);
  if (start > 0) html = html.slice(start);
  const extras = CTA_BAR + LINK_GUARD;
  return /<\/body>/i.test(html) ? html.replace(/<\/body>/i, `${extras}</body>`) : html + extras;
};

const log = (consoleEl, text, color = "#00ff00") => {
  const p = document.createElement("p");
  p.textContent = "> " + text;
  p.style.color = color;
  p.style.fontWeight = "bold";
  consoleEl.prepend(p);
};

async function streamSite(bizName, onChunk) {
  const res = await fetch(`${API}/generate-site`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ business: bizName }),
  });
  if (res.status === 429) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data?.detail ?? "Daily limit reached");
    err.limit = true;
    throw err;
  }
  if (!res.ok || !res.body) throw new Error("Generator unavailable");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let html = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const ev of events) {
      const line = ev.replace(/^data: /, "");
      if (line === "[DONE]") return html;
      const data = JSON.parse(line);
      if (data.error) throw new Error(data.error);
      html += data.t ?? "";
      onChunk(html.length);
    }
  }
  return html;
}

let running = false;

export async function executeGenerator() {
  if (running) return;
  const bizName = document.getElementById("biz-input")?.value.trim();
  if (!bizName) return alert("Enter your business name");

  const panel = document.getElementById("preview-panel");
  const loader = document.getElementById("loader-screen");
  const bar = document.getElementById("p-bar");
  const msg = document.getElementById("loader-msg");
  const frame = document.getElementById("live-site-frame");
  const term = document.getElementById("term-console");
  const btn = document.getElementById("gen-btn");

  running = true;
  btn.textContent = "Generating...";
  btn.disabled = true;
  panel.style.display = "block";
  loader.style.display = "block";
  frame.style.display = "none";
  bar.style.width = "2%";
  msg.textContent = "INITIALIZING NEURAL WEAVER...";
  msg.style.fontSize = "";
  loader.querySelector("[data-testid='limit-purchase-button']")?.remove();
  panel.scrollIntoView({ behavior: "smooth", block: "center" });
  log(term, `Building engine for "${bizName}"`);

  let lastStep = -1;
  const onChunk = (len) => {
    const progress = Math.min(95, 5 + (len / 14000) * 90);
    bar.style.width = progress + "%";
    const step = Math.min(STEPS.length - 1, Math.floor(progress / 20));
    if (step !== lastStep) {
      lastStep = step;
      msg.textContent = STEPS[step];
      log(term, STEPS[step]);
    }
  };

  try {
    const raw = await streamSite(bizName, onChunk);
    bar.style.width = "100%";
    msg.textContent = "FINALIZING...";
    log(term, "Live build deployed to preview");
    frame.srcdoc = cleanHtml(raw);
    setTimeout(() => {
      loader.style.display = "none";
      frame.style.display = "block";
    }, 400);
  } catch (e) {
    msg.textContent = e.limit ? e.message : "GENERATION FAILED — PLEASE TRY AGAIN";
    bar.style.width = e.limit ? "100%" : bar.style.width;
    log(term, (e.limit ? "Limit: " : "Generation failed: ") + e.message, "#ff5252");
    if (e.limit) {
      msg.style.fontSize = "clamp(22px, 3vw, 34px)";
      const go = document.createElement("button");
      go.className = "btn btn-blue";
      go.style.marginTop = "30px";
      go.textContent = "PURCHASE TO GO LIVE";
      go.setAttribute("data-testid", "limit-purchase-button");
      go.onclick = () => window.open(CHECKOUT, "_blank");
      if (!loader.querySelector("[data-testid='limit-purchase-button']")) loader.appendChild(go);
    }
  } finally {
    running = false;
    btn.textContent = "Generate Live Site";
    btn.disabled = false;
  }
}
